var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var TabTrigger = /** @class */ (function (_super) {
    __extends(TabTrigger, _super);
    function TabTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TabTrigger.prototype.render = function () {
        return (React.createElement("sb-tab-trigger", { "data-tab-link": this.props.link, "data-tab-default": this.props.default, "data-tab-trigger": !this.props.disabled, onClick: this.props.handler }, this.props.children));
    };
    return TabTrigger;
}(React.Component));
export { TabTrigger };
//# sourceMappingURL=TabTrigger.js.map